/** Ciclo completo del preview (suficientemente lento para distinguir la transición). */
export const PAGE_TRANSITION_PREVIEW_CYCLE_S = 4.2;
export const PAGE_TRANSITION_PREVIEW_TRANSITION_S = 1.05;

export const PAGE_TRANSITION_PREVIEW_CSS = `
	.er-pt-prev__stage {
		position: relative;
		width: 100%;
		height: 72px;
		border-radius: 8px;
		overflow: hidden;
		background: #0f172a;
		box-shadow: inset 0 0 0 1px rgba(255,255,255,0.06);
	}
	.er-pt-prev__page {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 11px;
		font-weight: 700;
		letter-spacing: 0.06em;
		color: rgba(255,255,255,0.85);
	}
	.er-pt-prev__page--a { background: linear-gradient(145deg, #64748b 0%, #475569 100%); z-index: 1; }
	.er-pt-prev__page--b { background: linear-gradient(145deg, #a78bfa 0%, #7c3aed 100%); z-index: 2; }
	.er-pt-prev__panels {
		position: absolute;
		inset: 8px;
		display: grid;
		grid-template-rows: 1fr 1fr 1fr;
		gap: 5px;
	}
	.er-pt-prev__panel {
		border-radius: 4px;
		background: rgba(255,255,255,0.92);
		box-shadow: 0 1px 3px rgba(0,0,0,0.12);
		opacity: 0;
	}
	.er-pt-prev__overlay {
		position: absolute;
		inset: 0;
		z-index: 20;
		pointer-events: none;
		border-radius: inherit;
	}
	.er-pt-prev__glitch-band {
		position: absolute;
		left: -8%;
		right: -8%;
		height: 22%;
		mix-blend-mode: screen;
		opacity: 0;
	}
	.er-pt-prev__glitch-band--a { top: 12%; background: linear-gradient(90deg, rgba(255,0,200,0.55), transparent 70%); }
	.er-pt-prev__glitch-band--b { top: 42%; background: linear-gradient(270deg, rgba(0,229,255,0.55), transparent 70%); }
	.er-pt-prev__glitch-band--c { top: 72%; background: linear-gradient(90deg, rgba(255,0,200,0.4), transparent 65%); }
	.er-pt-prev__mist-base {
		position: absolute;
		inset: 0;
		background:
			radial-gradient(ellipse 110% 70% at 50% 100%, rgba(148, 163, 184, 0.55), transparent 58%),
			radial-gradient(ellipse 80% 50% at 25% 35%, rgba(186, 198, 212, 0.42), transparent 52%),
			linear-gradient(180deg, rgba(100, 116, 139, 0.2) 0%, rgba(226, 232, 240, 0.15) 100%);
		backdrop-filter: blur(5px) saturate(0.5);
	}
	.er-pt-prev__mist-wisp {
		position: absolute;
		inset: -15%;
		filter: blur(10px);
		opacity: 0.85;
	}
	.er-pt-prev__mist-wisp--a {
		background: radial-gradient(ellipse 55% 45% at 30% 60%, rgba(255, 255, 255, 0.9), transparent 68%);
	}
	.er-pt-prev__mist-wisp--b {
		background: radial-gradient(ellipse 50% 40% at 70% 35%, rgba(232, 240, 248, 0.88), transparent 65%);
	}
	.er-pt-prev__clinical-scan {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		height: 45%;
		background: linear-gradient(180deg, rgba(203, 255, 151, 0.45) 0%, transparent 100%);
		opacity: 0;
	}
	.er-pt-prev__clinical-ecg {
		position: absolute;
		left: 4%;
		right: 4%;
		top: 10%;
		height: 28px;
		overflow: visible;
	}
	.er-pt-prev__clinical-ecg path {
		fill: none;
		stroke: #10b981;
		stroke-width: 2;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-dasharray: 180;
		stroke-dashoffset: 180;
		opacity: 0;
	}
	.er-pt-prev__assembly-guides {
		position: absolute;
		left: 18%;
		right: 18%;
		top: 38%;
		bottom: 38%;
	}
	.er-pt-prev__assembly-corner {
		position: absolute;
		width: 8px;
		height: 8px;
		border: 0 solid rgba(255,255,255,0.95);
		filter: drop-shadow(0 0 1px rgba(0,0,0,0.55));
	}
	.er-pt-prev__assembly-corner--tl { top: -2px; left: -2px; border-top-width: 1.5px; border-left-width: 1.5px; --er-bx: -5px; --er-by: -5px; }
	.er-pt-prev__assembly-corner--tr { top: -2px; right: -2px; border-top-width: 1.5px; border-right-width: 1.5px; --er-bx: 5px; --er-by: -5px; }
	.er-pt-prev__assembly-corner--bl { bottom: -2px; left: -2px; border-bottom-width: 1.5px; border-left-width: 1.5px; --er-bx: -5px; --er-by: 5px; }
	.er-pt-prev__assembly-corner--br { bottom: -2px; right: -2px; border-bottom-width: 1.5px; border-right-width: 1.5px; --er-bx: 5px; --er-by: 5px; }
	.er-pt-prev__flash {
		position: absolute;
		inset: 0;
		background: #fff;
		opacity: 0;
		z-index: 25;
	}
	.er-pt-prev:not(.er-pt-prev--playing) .er-pt-prev__page--b {
		opacity: 0.2;
		transform: none;
		filter: none;
	}
	.er-pt-prev:not(.er-pt-prev--playing) .er-pt-prev__panel {
		opacity: 0.35;
		transform: none;
		filter: none;
	}
	.er-pt-prev:not(.er-pt-prev--playing) .er-pt-prev__overlay,
	.er-pt-prev:not(.er-pt-prev--playing) .er-pt-prev__flash {
		display: none;
	}

	@keyframes er-pt-prev-cycle-a-fade {
		0%, 17%, 83%, 100% { opacity: 1; transform: none; filter: none; }
		20%, 42% { opacity: 0; }
		58%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-b-fade {
		0%, 17%, 83%, 100% { opacity: 0; transform: none; filter: none; }
		42%, 58% { opacity: 1; }
		20%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-a-slideLeft {
		0%, 17%, 83%, 100% { opacity: 1; transform: translateX(0); }
		20%, 42% { opacity: 0; transform: translateX(-28%); }
		58%, 80% { opacity: 0; transform: translateX(28%); }
	}
	@keyframes er-pt-prev-cycle-b-slideLeft {
		0%, 17%, 83%, 100% { opacity: 0; transform: translateX(28%); }
		42%, 58% { opacity: 1; transform: translateX(0); }
		20%, 80% { opacity: 0; transform: translateX(28%); }
	}
	@keyframes er-pt-prev-cycle-a-slideRight {
		0%, 17%, 83%, 100% { opacity: 1; transform: translateX(0); }
		20%, 42% { opacity: 0; transform: translateX(28%); }
		58%, 80% { opacity: 0; transform: translateX(-28%); }
	}
	@keyframes er-pt-prev-cycle-b-slideRight {
		0%, 17%, 83%, 100% { opacity: 0; transform: translateX(-28%); }
		42%, 58% { opacity: 1; transform: translateX(0); }
		20%, 80% { opacity: 0; transform: translateX(-28%); }
	}
	@keyframes er-pt-prev-cycle-a-slideUp {
		0%, 17%, 83%, 100% { opacity: 1; transform: translateY(0); }
		20%, 42% { opacity: 0; transform: translateY(-28%); }
		58%, 80% { opacity: 0; transform: translateY(28%); }
	}
	@keyframes er-pt-prev-cycle-b-slideUp {
		0%, 17%, 83%, 100% { opacity: 0; transform: translateY(28%); }
		42%, 58% { opacity: 1; transform: translateY(0); }
		20%, 80% { opacity: 0; transform: translateY(28%); }
	}
	@keyframes er-pt-prev-cycle-a-slideDown {
		0%, 17%, 83%, 100% { opacity: 1; transform: translateY(0); }
		20%, 42% { opacity: 0; transform: translateY(28%); }
		58%, 80% { opacity: 0; transform: translateY(-28%); }
	}
	@keyframes er-pt-prev-cycle-b-slideDown {
		0%, 17%, 83%, 100% { opacity: 0; transform: translateY(-28%); }
		42%, 58% { opacity: 1; transform: translateY(0); }
		20%, 80% { opacity: 0; transform: translateY(-28%); }
	}
	@keyframes er-pt-prev-cycle-a-zoom {
		0%, 17%, 83%, 100% { opacity: 1; transform: scale(1); }
		20%, 42% { opacity: 0; transform: scale(0.9); }
		58%, 80% { opacity: 0; transform: scale(1.06); }
	}
	@keyframes er-pt-prev-cycle-b-zoom {
		0%, 17%, 83%, 100% { opacity: 0; transform: scale(0.88); }
		42%, 58% { opacity: 1; transform: scale(1); }
		20%, 80% { opacity: 0; transform: scale(0.88); }
	}
	@keyframes er-pt-prev-cycle-a-none {
		0%, 17%, 83%, 100% { opacity: 1; }
		19%, 42% { opacity: 0; }
		58%, 81% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-b-none {
		0%, 17%, 83%, 100% { opacity: 0; }
		19%, 42% { opacity: 1; }
		58%, 81% { opacity: 1; }
	}
	@keyframes er-pt-prev-cycle-a-glitch {
		0%, 17%, 83%, 100% { opacity: 1; transform: translate(0); filter: none; }
		22% { opacity: 1; transform: translate(-2px, 1px); filter: contrast(1.2); }
		28% { opacity: 0.4; transform: translate(3px, -1px); }
		35%, 42% { opacity: 0; transform: translate(-2px, 0); }
		58%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-b-glitch {
		0%, 17%, 83%, 100% { opacity: 0; transform: translate(0); filter: none; }
		35% { opacity: 0.5; transform: translate(2px, 0); filter: drop-shadow(2px 0 #ff00c8); }
		42%, 58% { opacity: 1; transform: translate(0); filter: none; }
		65% { opacity: 0.6; transform: translate(-2px, 1px); }
		80% { opacity: 0; }
	}
	@keyframes er-pt-prev-glitch-overlay {
		0%, 16%, 44%, 56%, 84%, 100% { opacity: 0; }
		20%, 40% { opacity: 1; }
		60%, 80% { opacity: 1; }
	}
	@keyframes er-pt-prev-glitch-band {
		0%, 16%, 44%, 56%, 84%, 100% { opacity: 0; transform: translateX(0); }
		22% { opacity: 0.85; transform: translateX(-8px); }
		30% { opacity: 0.6; transform: translateX(6px); }
		38% { opacity: 0.75; transform: translateX(-4px); }
		62% { opacity: 0.85; transform: translateX(8px); }
		70% { opacity: 0.6; transform: translateX(-6px); }
		78% { opacity: 0.5; transform: translateX(3px); }
	}
	@keyframes er-pt-prev-cycle-b-comic {
		0%, 17%, 83%, 100% { opacity: 0; }
		20%, 58% { opacity: 1; }
		62%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-panel-comic-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: scale(0.2) rotate(-8deg); }
		24%, 58% { opacity: 1; transform: scale(1) rotate(0deg); }
		62%, 80% { opacity: 0; transform: scale(0.9); }
	}
	@keyframes er-pt-prev-panel-comic-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: scale(0.2) rotate(6deg); }
		30%, 58% { opacity: 1; transform: scale(1) rotate(0deg); }
		62%, 80% { opacity: 0; transform: scale(0.9); }
	}
	@keyframes er-pt-prev-panel-comic-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: scale(0.2) rotate(-5deg); }
		36%, 58% { opacity: 1; transform: scale(1) rotate(0deg); }
		62%, 80% { opacity: 0; transform: scale(0.9); }
	}
	@keyframes er-pt-prev-cycle-b-scatter {
		0%, 17%, 83%, 100% { opacity: 0; }
		20%, 58% { opacity: 1; }
		62%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-panel-scatter-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: translate(-18px, -14px) scale(0.85); filter: blur(6px); }
		28%, 58% { opacity: 1; transform: translate(0, 0) scale(1); filter: none; }
		62%, 80% { opacity: 0; transform: translate(-12px, 0) scale(0.92); filter: blur(3px); }
	}
	@keyframes er-pt-prev-panel-scatter-2 {
		0%, 22%, 83%, 100% { opacity: 0; transform: translate(20px, 4px) scale(0.85); filter: blur(6px); }
		32%, 58% { opacity: 1; transform: translate(0, 0) scale(1); filter: none; }
		62%, 80% { opacity: 0; transform: translate(14px, 0) scale(0.92); filter: blur(3px); }
	}
	@keyframes er-pt-prev-panel-scatter-3 {
		0%, 25%, 83%, 100% { opacity: 0; transform: translate(-6px, 18px) scale(0.85); filter: blur(6px); }
		36%, 58% { opacity: 1; transform: translate(0, 0) scale(1); filter: none; }
		62%, 80% { opacity: 0; transform: translate(0, 12px) scale(0.92); filter: blur(3px); }
	}
	@keyframes er-pt-prev-cycle-b-reveal {
		0%, 17%, 83%, 100% { opacity: 0; filter: brightness(0.55) saturate(0.9); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: brightness(0.7); }
	}
	@keyframes er-pt-prev-panel-reveal-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: translateY(-28px) rotate(-8deg) scale(0.86); filter: drop-shadow(0 0 0 rgba(0,0,0,0)); }
		32%, 58% { opacity: 1; transform: translateY(0) rotate(0deg) scale(1); filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15)); }
		62%, 80% { opacity: 0; transform: translateY(-12px) rotate(-4deg) scale(0.92); }
	}
	@keyframes er-pt-prev-panel-reveal-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: translateY(-32px) rotate(7deg) scale(0.86); filter: drop-shadow(0 0 0 rgba(0,0,0,0)); }
		38%, 58% { opacity: 1; transform: translateY(0) rotate(0deg) scale(1); filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15)); }
		62%, 80% { opacity: 0; transform: translateY(-12px) rotate(4deg) scale(0.92); }
	}
	@keyframes er-pt-prev-panel-reveal-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: translateY(-36px) rotate(-5deg) scale(0.86); filter: drop-shadow(0 0 0 rgba(0,0,0,0)); }
		42%, 58% { opacity: 1; transform: translateY(0) rotate(0deg) scale(1); filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15)); }
		62%, 80% { opacity: 0; transform: translateY(-12px) rotate(-3deg) scale(0.92); }
	}
	@keyframes er-pt-prev-cycle-b-materialize {
		0%, 17%, 83%, 100% { opacity: 0; filter: blur(3px) saturate(0.35) brightness(0.65); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: blur(2px) saturate(0.5) brightness(0.75); }
	}
	@keyframes er-pt-prev-panel-materialize-1 {
		0%, 19%, 83%, 100% { opacity: 0; filter: blur(10px) saturate(0.1) brightness(1.8); }
		32%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: blur(6px) saturate(0.25) brightness(1.4); }
	}
	@keyframes er-pt-prev-panel-materialize-2 {
		0%, 24%, 83%, 100% { opacity: 0; filter: blur(11px) saturate(0.1) brightness(1.85); }
		36%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: blur(6px) saturate(0.25) brightness(1.4); }
	}
	@keyframes er-pt-prev-panel-materialize-3 {
		0%, 29%, 83%, 100% { opacity: 0; filter: blur(12px) saturate(0.1) brightness(1.9); }
		40%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: blur(6px) saturate(0.25) brightness(1.4); }
	}
	@keyframes er-pt-prev-cycle-b-build {
		0%, 17%, 83%, 100% { opacity: 0; filter: brightness(0.88) contrast(1.04); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-panel-build-1 {
		0%, 19%, 83%, 100% {
			opacity: 0;
			transform: translate3d(-10px, -3px, 0) scale(1.015);
			filter: drop-shadow(0 8px 12px rgba(0,0,0,0.28));
		}
		34% { opacity: 1; transform: translate3d(0,0,0) scale(1); filter: drop-shadow(0 3px 6px rgba(0,0,0,0.14)); }
		42%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translate3d(-8px, -2px, 0); }
	}
	@keyframes er-pt-prev-panel-build-2 {
		0%, 24%, 83%, 100% {
			opacity: 0;
			transform: translate3d(11px, 3px, 0) scale(1.015);
			filter: drop-shadow(0 8px 12px rgba(0,0,0,0.28));
		}
		38% { opacity: 1; transform: translate3d(0,0,0) scale(1); filter: drop-shadow(0 3px 6px rgba(0,0,0,0.14)); }
		46%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translate3d(8px, 2px, 0); }
	}
	@keyframes er-pt-prev-panel-build-3 {
		0%, 29%, 83%, 100% {
			opacity: 0;
			transform: translate3d(0, 10px, 0) scale(1.015);
			filter: drop-shadow(0 8px 12px rgba(0,0,0,0.28));
		}
		42% { opacity: 1; transform: translate3d(0,-1px,0) scale(1); filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1)); }
		50%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translate3d(0, 8px, 0); }
	}
	@keyframes er-pt-prev-assembly-overlay {
		0%, 17% { opacity: 0; }
		22% { opacity: 1; }
		50% { opacity: 0.85; }
		58% { opacity: 0; }
		62%, 100% { opacity: 0; }
	}
	@keyframes er-pt-prev-assembly-bracket {
		0%, 20% { opacity: 0; transform: translate3d(var(--er-bx,0), var(--er-by,0), 0); }
		28% { opacity: 0.95; transform: none; }
		48% { opacity: 0.9; }
		58% { opacity: 0; }
		62%, 100% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-b-static {
		0%, 17%, 83%, 100% { opacity: 0; filter: contrast(2.2) brightness(1.5) saturate(0); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: contrast(1.6) brightness(1.2); }
	}
	@keyframes er-pt-prev-panel-static-1 {
		0%, 19%, 83%, 100% { opacity: 0.2; filter: contrast(3.5) brightness(2) blur(1px); }
		32%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0.3; filter: contrast(2) brightness(1.5) blur(0.5px); }
	}
	@keyframes er-pt-prev-panel-static-2 {
		0%, 24%, 83%, 100% { opacity: 0.2; filter: contrast(3.5) brightness(2) blur(1px); }
		36%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0.3; filter: contrast(2) brightness(1.5) blur(0.5px); }
	}
	@keyframes er-pt-prev-panel-static-3 {
		0%, 29%, 83%, 100% { opacity: 0.2; filter: contrast(3.5) brightness(2) blur(1px); }
		40%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0.3; filter: contrast(2) brightness(1.5) blur(0.5px); }
	}
	@keyframes er-pt-prev-cycle-b-thermal {
		0%, 17%, 83%, 100% { opacity: 0; filter: brightness(0.35) saturate(1.5); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: brightness(0.5) saturate(1.3); }
	}
	@keyframes er-pt-prev-panel-thermal-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: scale(0.88); filter: blur(6px) brightness(2.2) drop-shadow(0 0 14px rgba(0,255,220,0.9)); }
		30%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(0.92); filter: blur(3px) brightness(1.6) drop-shadow(0 0 8px rgba(0,255,220,0.5)); }
	}
	@keyframes er-pt-prev-panel-thermal-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: scale(0.88); filter: blur(6px) brightness(2.2) hue-rotate(40deg) drop-shadow(0 0 14px rgba(255,0,200,0.85)); }
		34%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(0.92); filter: blur(3px) brightness(1.6) drop-shadow(0 0 8px rgba(255,0,200,0.45)); }
	}
	@keyframes er-pt-prev-panel-thermal-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: scale(0.88); filter: blur(6px) brightness(2.2) hue-rotate(-35deg) drop-shadow(0 0 14px rgba(120,255,180,0.85)); }
		38%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(0.92); filter: blur(3px) brightness(1.6) drop-shadow(0 0 8px rgba(120,255,180,0.45)); }
	}
	@keyframes er-pt-prev-cycle-b-softGlitch {
		0%, 17%, 83%, 100% { opacity: 0; filter: contrast(2) saturate(0.6) brightness(1.3); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: contrast(1.5) saturate(0.8); }
	}
	@keyframes er-pt-prev-panel-softGlitch-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: translate(9px, -4px) skewX(5deg) scale(1.08); filter: drop-shadow(10px 0 #ff00c8) drop-shadow(-10px 0 #00e5ff) contrast(2.6) brightness(1.5); }
		30%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translate(5px, -2px) skewX(3deg); filter: drop-shadow(5px 0 rgba(255,0,200,0.6)) drop-shadow(-5px 0 rgba(0,229,255,0.6)); }
	}
	@keyframes er-pt-prev-panel-softGlitch-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: translate(-8px, 3px) skewX(-4deg) scale(1.06); filter: drop-shadow(-9px 0 #ff00c8) drop-shadow(9px 0 #00e5ff) contrast(2.5) brightness(1.45); }
		34%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translate(-4px, 2px) skewX(-2deg); filter: drop-shadow(4px 0 rgba(255,0,200,0.5)) drop-shadow(-4px 0 rgba(0,229,255,0.5)); }
	}
	@keyframes er-pt-prev-panel-softGlitch-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: translate(7px, 2px) skewX(6deg) scale(1.07); filter: drop-shadow(8px 0 #ff00c8) drop-shadow(-8px 0 #00e5ff) contrast(2.4) brightness(1.4); }
		38%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translate(3px, 1px) skewX(2deg); filter: drop-shadow(3px 0 rgba(255,0,200,0.5)) drop-shadow(-3px 0 rgba(0,229,255,0.5)); }
	}
	@keyframes er-pt-prev-cycle-b-mist {
		0%, 17%, 83%, 100% { opacity: 0; filter: blur(14px) saturate(0.06) brightness(0.38) hue-rotate(208deg); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: blur(10px) saturate(0.1) brightness(0.48) hue-rotate(198deg); }
	}
	@keyframes er-pt-prev-mist-overlay {
		0%, 16%, 44%, 56%, 84%, 100% { opacity: 0; }
		18%, 42% { opacity: 1; }
		58%, 82% { opacity: 1; }
		40% { opacity: 0.98; }
		78% { opacity: 0.35; }
	}
	@keyframes er-pt-prev-mist-wisp {
		0%, 16%, 44%, 56%, 84%, 100% { opacity: 0; transform: translateX(0); }
		22% { opacity: 0.9; transform: translateX(-6%); }
		34% { opacity: 0.75; transform: translateX(4%); }
		62% { opacity: 0.88; transform: translateX(5%); }
		74% { opacity: 0.55; transform: translateX(-4%); }
	}
	@keyframes er-pt-prev-panel-mist-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: translateY(22px) scale(0.9); filter: blur(18px) saturate(0.08) brightness(1.6) hue-rotate(200deg); }
		32%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translateY(12px); filter: blur(10px) saturate(0.12) hue-rotate(192deg); }
	}
	@keyframes er-pt-prev-panel-mist-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: translateY(20px) scale(0.91); filter: blur(17px) saturate(0.08) brightness(1.58) hue-rotate(196deg); }
		34%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translateY(11px); filter: blur(9px) saturate(0.14) hue-rotate(188deg); }
	}
	@keyframes er-pt-prev-panel-mist-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: translateY(18px) scale(0.92); filter: blur(16px) saturate(0.09) brightness(1.55) hue-rotate(194deg); }
		36%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: translateY(10px); filter: blur(8px) saturate(0.16) hue-rotate(184deg); }
	}
	@keyframes er-pt-prev-cycle-b-shadow {
		0%, 17%, 83%, 100% { opacity: 0; filter: brightness(0.2) contrast(1.5) saturate(0.1); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: brightness(0.35) contrast(1.3); }
	}
	@keyframes er-pt-prev-panel-shadow-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: translateX(6px) scale(1.12); filter: brightness(0.15) contrast(1.85) blur(3px); }
		32%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(1.06); filter: brightness(0.35) contrast(1.5) blur(2px); }
	}
	@keyframes er-pt-prev-panel-shadow-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: translateX(-5px) scale(1.11); filter: brightness(0.16) contrast(1.8) blur(3px); }
		34%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(1.05); filter: brightness(0.38) contrast(1.45); }
	}
	@keyframes er-pt-prev-panel-shadow-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: translateX(4px) scale(1.1); filter: brightness(0.17) contrast(1.78) blur(2px); }
		36%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(1.04); filter: brightness(0.4) contrast(1.4); }
	}
	@keyframes er-pt-prev-cycle-b-omen {
		0%, 17%, 83%, 100% { opacity: 0; filter: brightness(0.35) saturate(0.3) hue-rotate(285deg); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: brightness(0.5) hue-rotate(275deg); }
	}
	@keyframes er-pt-prev-panel-omen-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: rotate(2deg) translateY(8px) scale(0.94); filter: blur(4px) brightness(1.6) hue-rotate(278deg) drop-shadow(0 0 12px rgba(76,29,149,0.7)); }
		30%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: rotate(1deg) scale(0.97); filter: brightness(1.3) hue-rotate(270deg); }
	}
	@keyframes er-pt-prev-panel-omen-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: rotate(-2deg) translateY(7px) scale(0.95); filter: blur(4px) brightness(1.55) hue-rotate(272deg) drop-shadow(0 0 10px rgba(88,28,135,0.65)); }
		34%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: rotate(-1deg); filter: brightness(1.25) hue-rotate(265deg); }
	}
	@keyframes er-pt-prev-panel-omen-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: rotate(3deg) translateY(6px) scale(0.93); filter: blur(5px) brightness(1.58) hue-rotate(282deg) drop-shadow(0 0 11px rgba(76,29,149,0.68)); }
		38%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: rotate(1.5deg); filter: brightness(1.28) hue-rotate(268deg); }
	}
	@keyframes er-pt-prev-cycle-b-clinical {
		0%, 17%, 83%, 100% { opacity: 0; filter: brightness(0.4) saturate(1.2) hue-rotate(-20deg); }
		20%, 58% { opacity: 1; filter: none; }
		62%, 80% { opacity: 0; filter: brightness(0.7) hue-rotate(-10deg); }
	}
	@keyframes er-pt-prev-panel-clinical-1 {
		0%, 19%, 83%, 100% { opacity: 0; transform: translateY(8px) scale(0.96); filter: blur(5px) brightness(1.3) hue-rotate(-18deg) drop-shadow(0 0 10px rgba(16,185,129,0.55)); }
		30%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(1.02); filter: brightness(1.08) drop-shadow(0 0 8px rgba(203,255,151,0.4)); }
	}
	@keyframes er-pt-prev-panel-clinical-2 {
		0%, 24%, 83%, 100% { opacity: 0; transform: translateY(7px) scale(0.97); filter: blur(4px) brightness(1.25) hue-rotate(-14deg) drop-shadow(0 0 9px rgba(16,185,129,0.5)); }
		34%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(1.015); filter: brightness(1.06) drop-shadow(0 0 6px rgba(203,255,151,0.35)); }
	}
	@keyframes er-pt-prev-panel-clinical-3 {
		0%, 29%, 83%, 100% { opacity: 0; transform: translateY(6px) scale(0.95); filter: blur(5px) brightness(1.28) hue-rotate(-16deg) drop-shadow(0 0 10px rgba(16,185,129,0.52)); }
		38%, 58% { opacity: 1; transform: none; filter: none; }
		62%, 80% { opacity: 0; transform: scale(1.02); filter: brightness(1.07) drop-shadow(0 0 7px rgba(203,255,151,0.38)); }
	}
	@keyframes er-pt-prev-clinical-ecg {
		0%, 17%, 83%, 100% { stroke-dashoffset: 180; opacity: 0; }
		22% { opacity: 1; }
		40%, 58% { stroke-dashoffset: 0; opacity: 0.9; }
		62%, 80% { opacity: 0; stroke-dashoffset: 0; }
	}
	@keyframes er-pt-prev-clinical-scan {
		0%, 17%, 83%, 100% { transform: translateY(-100%); opacity: 0; }
		22% { opacity: 0.4; }
		40%, 55% { transform: translateY(120%); opacity: 0; }
		62%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-flash-exit {
		0%, 16%, 84%, 100% { opacity: 0; }
		28% { opacity: 0; }
		36%, 40% { opacity: 1; }
		48% { opacity: 0.15; }
		64% { opacity: 0; }
		72%, 78% { opacity: 1; }
	}
	@keyframes er-pt-prev-flash-enter {
		0%, 16%, 84%, 100% { opacity: 0; }
		20%, 26% { opacity: 1; }
		40% { opacity: 0; }
		64% { opacity: 0; }
		70%, 76% { opacity: 1; }
		88% { opacity: 0; }
	}
	@keyframes er-pt-prev-flash-both {
		0%, 16%, 84%, 100% { opacity: 0; }
		20%, 24% { opacity: 1; }
		30% { opacity: 0; }
		66% { opacity: 0; }
		70%, 74% { opacity: 1; }
		82% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-b-flashExit {
		0%, 17%, 83%, 100% { opacity: 0; }
		40%, 58% { opacity: 1; }
		20%, 36% { opacity: 0; }
		64%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-b-flashEnter {
		0%, 17%, 83%, 100% { opacity: 0; }
		26%, 58% { opacity: 1; }
		20%, 24% { opacity: 0; }
		64%, 80% { opacity: 0; }
	}
	@keyframes er-pt-prev-cycle-b-flashBoth {
		0%, 17%, 83%, 100% { opacity: 0; }
		28%, 58% { opacity: 1; }
		20%, 26% { opacity: 0; }
		64%, 80% { opacity: 0; }
	}

	.er-pt-prev--playing[data-id="fade"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="fade"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="none"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-none var(--er-pt-cycle) steps(1, end) infinite; }
	.er-pt-prev--playing[data-id="none"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-none var(--er-pt-cycle) steps(1, end) infinite; }
	.er-pt-prev--playing[data-id="slideLeft"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-slideLeft var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="slideLeft"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-slideLeft var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="slideRight"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-slideRight var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="slideRight"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-slideRight var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="slideUp"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-slideUp var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="slideUp"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-slideUp var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="slideDown"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-slideDown var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="slideDown"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-slideDown var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="zoom"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-zoom var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="zoom"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-zoom var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="glitch"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-glitch var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="glitch"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-glitch var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="glitch"] .er-pt-prev__overlay { animation: er-pt-prev-glitch-overlay var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="glitch"] .er-pt-prev__glitch-band { animation: er-pt-prev-glitch-band var(--er-pt-cycle) steps(4) infinite; }
	.er-pt-prev--playing[data-id="comic"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="comic"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-comic var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="comic"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-comic-1 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="comic"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-comic-2 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="comic"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-comic-3 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="scatter"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="scatter"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-scatter var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="scatter"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-scatter-1 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="scatter"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-scatter-2 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="scatter"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-scatter-3 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="reveal"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="reveal"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-reveal var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="reveal"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-reveal-1 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="reveal"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-reveal-2 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="reveal"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-reveal-3 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="materialize"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="materialize"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-materialize var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="materialize"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-materialize-1 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="materialize"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-materialize-2 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="materialize"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-materialize-3 var(--er-pt-cycle) ease-out infinite; }
		.er-pt-prev--playing[data-id="build"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="build"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-build var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="build"] .er-pt-prev__overlay { animation: er-pt-prev-assembly-overlay var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="build"] .er-pt-prev__assembly-corner { animation: er-pt-prev-assembly-bracket var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="build"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-build-1 var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="build"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-build-2 var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="build"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-build-3 var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
.er-pt-prev--playing[data-id="static"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="static"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-static var(--er-pt-cycle) steps(6, end) infinite; }
	.er-pt-prev--playing[data-id="static"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-static-1 var(--er-pt-cycle) steps(6, end) infinite; }
	.er-pt-prev--playing[data-id="static"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-static-2 var(--er-pt-cycle) steps(6, end) infinite; }
	.er-pt-prev--playing[data-id="static"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-static-3 var(--er-pt-cycle) steps(6, end) infinite; }
	.er-pt-prev--playing[data-id="thermal"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="thermal"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-thermal var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="thermal"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-thermal-1 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="thermal"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-thermal-2 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="thermal"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-thermal-3 var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="softGlitch"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="softGlitch"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-softGlitch var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="softGlitch"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-softGlitch-1 var(--er-pt-cycle) steps(10, end) infinite; }
	.er-pt-prev--playing[data-id="softGlitch"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-softGlitch-2 var(--er-pt-cycle) steps(10, end) infinite; }
	.er-pt-prev--playing[data-id="softGlitch"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-softGlitch-3 var(--er-pt-cycle) steps(10, end) infinite; }
	.er-pt-prev--playing[data-id="mist"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="mist"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-mist var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="mist"] .er-pt-prev__overlay { animation: er-pt-prev-mist-overlay var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="mist"] .er-pt-prev__mist-wisp { animation: er-pt-prev-mist-wisp var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="mist"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-mist-1 var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="mist"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-mist-2 var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="mist"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-mist-3 var(--er-pt-cycle) cubic-bezier(0.16, 1, 0.3, 1) infinite; }
	.er-pt-prev--playing[data-id="shadow"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="shadow"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-shadow var(--er-pt-cycle) cubic-bezier(0.45, 0, 0.2, 1) infinite; }
	.er-pt-prev--playing[data-id="shadow"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-shadow-1 var(--er-pt-cycle) cubic-bezier(0.45, 0, 0.2, 1) infinite; }
	.er-pt-prev--playing[data-id="shadow"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-shadow-2 var(--er-pt-cycle) cubic-bezier(0.45, 0, 0.2, 1) infinite; }
	.er-pt-prev--playing[data-id="shadow"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-shadow-3 var(--er-pt-cycle) cubic-bezier(0.45, 0, 0.2, 1) infinite; }
	.er-pt-prev--playing[data-id="omen"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="omen"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-omen var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="omen"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-omen-1 var(--er-pt-cycle) steps(8, end) infinite; }
	.er-pt-prev--playing[data-id="omen"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-omen-2 var(--er-pt-cycle) steps(8, end) infinite; }
	.er-pt-prev--playing[data-id="omen"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-omen-3 var(--er-pt-cycle) steps(8, end) infinite; }
	.er-pt-prev--playing[data-id="clinical"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="clinical"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-clinical var(--er-pt-cycle) cubic-bezier(0.22, 1, 0.36, 1) infinite; }
	.er-pt-prev--playing[data-id="clinical"] .er-pt-prev__panel--1 { animation: er-pt-prev-panel-clinical-1 var(--er-pt-cycle) cubic-bezier(0.22, 1, 0.36, 1) infinite; }
	.er-pt-prev--playing[data-id="clinical"] .er-pt-prev__panel--2 { animation: er-pt-prev-panel-clinical-2 var(--er-pt-cycle) cubic-bezier(0.22, 1, 0.36, 1) infinite; }
	.er-pt-prev--playing[data-id="clinical"] .er-pt-prev__panel--3 { animation: er-pt-prev-panel-clinical-3 var(--er-pt-cycle) cubic-bezier(0.22, 1, 0.36, 1) infinite; }
	.er-pt-prev--playing[data-id="clinical"] .er-pt-prev__clinical-scan { animation: er-pt-prev-clinical-scan var(--er-pt-cycle) ease-out infinite; }
	.er-pt-prev--playing[data-id="clinical"] .er-pt-prev__clinical-ecg path { animation: er-pt-prev-clinical-ecg var(--er-pt-cycle) cubic-bezier(0.22, 1, 0.36, 1) infinite; }
	.er-pt-prev--playing[data-id="flashExit"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashExit"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-flashExit var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashExit"] .er-pt-prev__flash { animation: er-pt-prev-flash-exit var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashEnter"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashEnter"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-flashEnter var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashEnter"] .er-pt-prev__flash { animation: er-pt-prev-flash-enter var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashBoth"] .er-pt-prev__page--a { animation: er-pt-prev-cycle-a-fade var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashBoth"] .er-pt-prev__page--b { animation: er-pt-prev-cycle-b-flashBoth var(--er-pt-cycle) ease-in-out infinite; }
	.er-pt-prev--playing[data-id="flashBoth"] .er-pt-prev__flash { animation: er-pt-prev-flash-both var(--er-pt-cycle) ease-in-out infinite; }
`;
